<template>
  <div>
    <Filtro @projetoAstecFiltrados="atualizarFiltro" />

    <Relatorios />

    <div>
      <div class="text-center" v-if="loadingGridProjetos">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>

      <Grid
        v-else
        :items="projetosListados"
        :filtro="filtroProjetoAstec"
        :is-loading="loadingGridProjetos"
        @projetoAstecFiltrados="atualizarFiltro"
      />
    </div>
  </div>
</template>

<script>
import Filtro from "@/components/astec/projetos/filtro";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import Relatorios from "@/components/astec/projetos/Relatorios";
import Grid from "@/components/astec/projetos/gridProjetos";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Grid,
    Filtro,
    Relatorios,
  },
  data() {
    return {
      filtro: {},
      limparFiltro: false,
      filtroProjetoAstec: {},
      loadingGridProjetos: false,
      projetosListados: {
        data: [],
        total: 0,
        current_page: 1,
      },
    };
  },

  created() {
    this.$store.commit("PARAMETROS_PROJETO_ASTEC", null);
  },

  mounted() {},

  methods: {
    async atualizarFiltro(filtro, callback) {
      try {
        this.loadingGridProjetos = true;
        this.filtroProjetoAstec = filtro;

        const page = filtro.page || 1;
        const perPage = filtro.per_page || 10;

        const objFiltrado = await this.buscarItensProjetos(filtro, page, perPage);
        this.projetosListados = objFiltrado || {
          data: [],
          total: 0,
          current_page: 1,
        };

        if (typeof callback === "function") callback();
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingGridProjetos = false;
      }
    },
  },
};
</script>
